import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';
import {
  getPartnerProvidersApiUrl,
  NewLogisticProvidersFormBody,
  PatchLogisticProvidersFormBody,
  LogisticProvider,
  PaginatedLogisticProviderListFilters,
} from '@/api/apis/facilities';

const getPartnerProvidersList = async (params: PaginatedLogisticProviderListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<LogisticProvider>>(getPartnerProvidersApiUrl.list(), { params });
  return res.data.data;
};

const getPartnerProvidersById = async (txCenterId: string): Promise<LogisticProvider> => {
  const res = await http.get<ApiResponseBody<LogisticProvider>>(
    getPartnerProvidersApiUrl.logisticProviderById(txCenterId),
  );
  return res.data.data;
};

const updatePartnerProviderById = async ({ id, ...body }: PatchLogisticProvidersFormBody & { id: string }) => {
  const res = await http.patch<ApiResponseBody<LogisticProvider>>(
    getPartnerProvidersApiUrl.logisticProviderById(id),
    body,
  );
  return res.data.data;
};

const removePartnerProviderById = async (txCenterId: string): Promise<{ message: string }> => {
  const res = await http.delete<ApiResponseBody<{ message: string }>>(
    getPartnerProvidersApiUrl.logisticProviderById(txCenterId),
  );
  return res.data.data;
};

const createPartnerProvider = async (body: NewLogisticProvidersFormBody & { id: string }) => {
  const res = await http.post<ApiResponseBody<LogisticProvider>>(getPartnerProvidersApiUrl.list(), body);
  return res.data.data;
};

export const partnerProvidersApiFetcher = {
  getPartnerProvidersList,
  getPartnerProvidersById,
  updatePartnerProviderById,
  removePartnerProviderById,
  createPartnerProvider,
};
